export default __webpack_public_path__ + "static/media/Sanhita.8652c31b.jpg";